import {URLManager} from './URLManager';
import {Locale} from './Locale';
import {Environment} from './Environment';
import {colorValidator} from './Validators';

declare var $: any;
declare var window: any;
declare var componentHandler: any;
declare var ga: any;

export class UI {
    private static instance: UI;

    static getInstance(): UI {
        if (!UI.instance) {
            UI.instance = new UI();
        }
        return UI.instance;
    }

    /**
     * @summary Allows scroll to ID and URL update.
     * @since 16.15.20
     */
    public scrollOnLoad = (offset = 64, selector = null, callback = null) => {
        var section = URLManager.getInstance().getParams()['s'];
        if (!section || section.length < 2) return;
        var sectionElement = $('#' + section).length === 0 ? $('.' + section) : $('#' + section);

        $(function () {
            const targetElement = selector ? $(selector) : sectionElement;
            if (targetElement.length > 0) {
                $('html, body').animate(
                    {
                        scrollTop: targetElement.first().offset().top - offset,
                    },
                    500
                );
            }

            if (callback) {
                callback();
            }
        });
    };

    public domReady(fn, context = null) {
        const d = document as any;

        function onReady(event) {
            d.removeEventListener('DOMContentLoaded', onReady);
            fn.call(context, event);
        }

        function onReadyIe(event) {
            if (d.readyState === 'complete') {
                d.detachEvent('onreadystatechange', onReadyIe);
                fn.call(context, event);
            }
        }

        if (d.addEventListener) {
            d.addEventListener('DOMContentLoaded', onReady);
        } else if (d.attachEvent) {
            d.attachEvent('onreadystatechange', onReadyIe);
        }
    }

    public truncateText(s, n) {
        if (s.length <= n) return s;
        let ss = s.substr(0, n - 1);
        ss = ss.substr(0, ss.lastIndexOf(' '));
        return ss + '...';
    }

    public formatQuestion(requestType, firstName, lastName, phone, company, notes) {
        return (
            requestType +
            '\n' +
            notes +
            '\n\n' +
            firstName +
            ' ' +
            lastName +
            '\n' +
            phone +
            '\n' +
            company
        );
    }

    public swapText($selector) {
        const curTxt = $selector.find('span').text();

        $selector.find('span').text($selector.data('text'));

        $selector.data('text', curTxt);
    }

    public switchTabs($selector) {
        $selector.addClass('current').siblings().removeClass('current');
    }

    public escapeHtml(string) {
        var entityMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
        };
        return String(string).replace(/[&<>"'\/]/g, function (s) {
            return entityMap[s];
        });
    }

    public sortDropdownByValue(select: any) {
        $(select).html(
            $(select)
                .find('option')
                .sort((x, y) => {
                    return $(x).text().trim() > $(y).text().trim() ? 1 : -1;
                })
        );
    }

    public dropdownValidate(selector, failure = null, success = null) {
        failure == null ? (failure = 'keeper-invalid keeper-touched text-red') : '';
        success == null ? (success = 'text-black') : '';
        const value = $(selector).val() || false;
        const $dropdown = $(selector).siblings('button');
        value.length > 0
            ? success.length > 0
                ? $dropdown.removeClass(failure).addClass(success)
                : $dropdown.removeClass(failure)
            : $dropdown.addClass(failure);
    }

    public dropdownInitialize(selector, label, classes, submitButton, validate) {
        if (validate === undefined) validate = true;

        label == null
            ? $(selector).dropdown({label: 'Select Option'})
            : $(selector).dropdown({label});
        classes == null
            ? $(selector).siblings('button').addClass('placeholder field dropdown')
            : $(selector).siblings('button').addClass(classes);
        $(selector + '-dropdown button.field2').attr('data-desc', label); // if .field2 is used add data attribute for small descriptor

        if (validate === true) {
            $(selector).on('change', event => {
                this.dropdownValidate(selector);
            });
        } else {
            submitButton = null;
        }

        if ($(selector + '-dropdown')[0]) {
            $(selector + '-dropdown')[0].options = {};
            $(selector + '-dropdown')[0].selectedIndex = -1;
        }

        if (submitButton == null) {
            return;
        }

        $(submitButton).on('click', event => {
            this.dropdownValidate(selector);
        });
    }

    /**
     * @summary Returns the localized rating within a string template.
     * @param {float} rated - The unformatted rate to format.
     * @param {float} maxrate - The unformatted max rate to format.
     * @param {string} template - The string template to run replacements on.
     * @since 12.0.0
     * @returns {string} Template string with localized price.
     */

    public formatRatingForDisplay = (rated: any, maxrate: any, template) => {
        var comaSeparatedLocales = ['de_DE', 'es_ES', 'fr_FR', 'nl_NL', 'pl_PL', 'pt_BR', 'ru_RU'];
        var theLocale = Locale.getInstance().getCurrentLocale();

        if (comaSeparatedLocales.includes(theLocale)) {
            rated = rated.toString().replace('.', ',');
            maxrate = maxrate.toString().replace('.', ',');
        }

        var rating = template.replace(
            '<span class="rated"></span>',
            '<span class="rated">' + rated + '</span>'
        );
        rating = rating.replace(
            '<span class="max-rate"></span>',
            '<span class="max-rate">' + maxrate + '</span>'
        );

        return rating;
    };

    /**
     * @summary Automatically transforms intro tab dropdowns to FormStone.
     * @since 12.0.0
     */
    public initMobileTabs = () => {
        const tabs: any = document.querySelector('.intro .mobile-tabs');
        if (!tabs || tabs.length < 1) return;

        tabs.childNodes.forEach((option: any) => {
            const url = window.location.href;
            if (url.indexOf(option.value) > -1) {
                $(tabs).children().removeAttr('selected');
                option.setAttribute('selected', 'selected');
            }
        });

        this.dropdown('.intro .mobile-tabs', null, 'dropdown field');

        $('.intro .mobile-tabs').on('change', function () {
            try {
                const path = $('.intro .mobile-tabs').val();
                const url = new URL(path, window.location.origin);
                if (
                    url &&
                    (url.search !== window.location.search ||
                        window.location.pathname.indexOf(url.pathname) === -1)
                ) {
                    window.location = url.href;
                }
            } catch (e) {
                console.error(e);
            }
            return false;
        });
    };

    /**
     * @summary Converts native select to FormStone dropdown.
     * @param {element} select - Dropdown to convert.
     * @param {string} label - Default visible label to show user.
     * @param {string} css - Styles to add to the dropdown.
     * @param {boolean} validate - Whether validation should be enabled or not.
     * @param {element} submit - Submit button to tie the click event validation to.
     * @since 12.0.00
     * @returns {string} Template string with localized price.
     */
    public dropdown = (select, label, css, validate = false, submit = false) => {
        var promise = new Promise<void>(resolve => {
            if (!label) label = 'Select Option';
            if (!css) css = 'placeholder field dropdown';

            const createDropdown = () => {
                $(select).dropdown({label});
                $(select).siblings('button').addClass(css);

                if (validate) {
                    $(select).on('change', event => {
                        this.dropdownValidate(select);
                    });
                }

                if (submit) {
                    $(submit).on('click', event => {
                        this.dropdownValidate(select);
                    });
                }

                // Initialize scroll gradient
                this.initDropdownScrollGradient(select);

                resolve();
            };

            if ($.fn.dropdown) {
                createDropdown();
            } else {
                $(function () {
                    createDropdown();
                });
            }
        });
        return promise;
    };

    /**
     * @summary Initializes scroll-based gradient effects for dropdown options
     * @param {string|element} select - The select element or selector
     * @since 12.0.0
     */
    public initDropdownScrollGradient = select => {
        const $select = $(select);

        // Add class immediately to all dropdown options
        setTimeout(() => {
            const $dropdownOptions = $select.siblings('.fs-dropdown-options');
            if ($dropdownOptions.length > 0 && $select.data('scrollable-gradient') !== undefined) {
                $dropdownOptions.addClass('scrollable-gradient');

                const element = $dropdownOptions[0];

                // Set gradient color if specified via data attribute
                const gradientColor = $select.data('gradient-color');
                if (gradientColor && colorValidator(gradientColor)) {
                    element.style.setProperty('--gradient-color', gradientColor);
                }

                // Check if content needs scrolling
                const needsScroll = () => {
                    return element.scrollHeight > element.clientHeight;
                };

                // Set default initial state (will be updated when dropdown opens)
                element.style.setProperty('--gradient-top-opacity', 0);
                element.style.setProperty('--gradient-bottom-opacity', 1);

                // Function to update gradient state
                const updateGradients = () => {
                    if ($dropdownOptions.is(':visible')) {
                        element.style.setProperty('--gradient-top-opacity', 0);
                        element.style.setProperty(
                            '--gradient-bottom-opacity',
                            needsScroll() ? 1 : 0
                        );
                    }
                };

                // Update gradients when dropdown opens
                $select.parent('.fs-dropdown').on('click', () => {
                    setTimeout(updateGradients, 50);
                });

                // Handle scroll events with throttling to prevent forced reflows
                let scrollTimeout;
                $dropdownOptions.on('scroll', function () {
                    clearTimeout(scrollTimeout);
                    scrollTimeout = setTimeout(() => {
                        requestAnimationFrame(() => {
                            // Batch all DOM reads first to prevent forced reflows
                            const scrollTop = this.scrollTop;
                            const scrollHeight = this.scrollHeight;
                            const clientHeight = this.clientHeight;
                            const scrollBottom = scrollHeight - scrollTop - clientHeight;

                            // Fade tolerance in pixels
                            const fadeThreshold = 5;

                            // Calculate opacity for gradients
                            const canScroll = scrollHeight > clientHeight;

                            // Top gradient: show when scrolled away from top
                            const topOpacity = scrollTop > fadeThreshold && canScroll ? 1 : 0;

                            // Bottom gradient: show when not at bottom
                            const bottomOpacity = scrollBottom > fadeThreshold && canScroll ? 1 : 0;

                            // Apply CSS custom properties (batched writes)
                            this.style.setProperty('--gradient-top-opacity', topOpacity.toString());
                            this.style.setProperty(
                                '--gradient-bottom-opacity',
                                bottomOpacity.toString()
                            );
                        });
                    }, 16); // ~60fps throttling
                });
            }
        }, 50);
    };

    /**
     * @summary Initializes dropdowns dynamically.
     * @since 12.0.0
     */
    public initDropdowns = () => {
        let locale = Locale.getInstance();
        const $countryMDLs = $('[data-keeper-component="country-mdl"]');
        $countryMDLs.each((index, item) => {
            try {
                const id = '#' + $(item).attr('id');
                const label = $(item).data('keeper-label');
                $(id).val('United States').trigger('change');
                this.sortDropdownByValue(id);
                this.dropdown(id, label || '', label ? 'field dropdown' : '').then(() => {
                    if ($(id).find('[selected]').get(0) !== undefined) {
                        $(id).val($(id).find('[selected]').get(0).value).trigger('change');
                    }
                    locale.embedCountryPhoneExtensions(id);
                    locale.embedCountryFlags(id);
                    locale.dropdownAutoSelectCountry(id);
                    $(id).parent().siblings('label').addClass('optionSelected');
                });
            } catch (e) {
                console.error('Error: Encountered error while trying to initialize dropdowns.');
                console.error(e);
            }
        });

        const $countries = $('[data-keeper-component="country"]');
        $countries.each((index, item) => {
            try {
                const id = '#' + $(item).attr('id');
                const label = $(item).data('keeper-label');
                $(id).val('United States').trigger('change');
                this.sortDropdownByValue(id);
                this.dropdown(id, label || '', label ? 'field dropdown' : '').then(() => {
                    if ($(id).find('[selected]').get(0) !== undefined) {
                        $(id).val($(id).find('[selected]').get(0).value).trigger('change');
                    }
                    locale.embedCountryPhoneExtensions(id);
                    locale.embedCountryFlags(id);
                    locale.dropdownAutoSelectCountry(id);
                });
            } catch (e) {
                console.error('Error: Encountered error while trying to initialize dropdowns.');
                console.error(e);
            }
        });

        const $dropdowns = $(document).find('[data-keeper-component="dropdown"]');
        $dropdowns.each((index, item) => {
            try {
                const id = '#' + $(document).find(item).attr('id');
                const label = $(document).find(item).data('keeper-label');
                this.dropdown(id, label || '', label ? 'field dropdown' : '');
                if ($(document).find(id).find('[selected]').get(0) !== undefined) {
                    $(document)
                        .find(id)
                        .val($(document).find(id).find('[selected]').get(0).value)
                        .trigger('change');
                }
                $(document)
                    .find(id)
                    .on('change', function () {
                        $(document).find(id).parent().siblings('label').addClass('optionSelected');
                    });
            } catch (e) {
                console.error('Error: Encountered error while trying to initialize dropdowns.');
                console.error(e);
            }
        });
    };

    /**
     * @summary Apply material-icons IE fix.
     * @since 12.0.0
     */
    public applyMaterialIconsFixForIE = () => {
        const isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
        if (isIE11) {
            $("i.material-icons:contains('clear')").each(function (index, value) {
                if ($(value).text() == 'clear') {
                    $(value).text('X');
                }
            });
        }
    };

    public openPopup = () => {
        $('.header, .main, .footer').removeClass('blurForModal');
        $('body').addClass('no-scroll');
    };

    public closePopup = () => {
        $('.header, .main, .footer').removeClass('blurForModal');
        $('body').removeClass('no-scroll');
    };

    public updatePillsVisibility(hidePillsAt) {
        if ($(window).width() <= hidePillsAt) {
            $(document).find('.intro .tabs').addClass('dropdownVisible');
            $(document).find('.intro .tabs').removeClass('pillVisible');
        } else {
            $(document).find('.intro .tabs').removeClass('dropdownVisible');
            $(document).find('.intro .tabs').addClass('pillVisible');
        }
    }

    public setPillMaxWidth(largestBtnWidth) {
        $(document)
            .find('.intro .tabs .tab')
            .css('max-width', largestBtnWidth + 'px');
    }

    public dynamicPills() {
        let locale = Locale.getInstance();
        /********** MAX PILL WIDTH CALCULATION OFFSET FROM AVERAGE **********/
        const btnLabelsLengths = $('.tabs .tab a')
            .map((i, el) => {
                return $(el).text().length;
            })
            .get();

        const longestBtn = Math.max.apply(this, btnLabelsLengths);

        const charWidth = {
            ar_AR: 11,
            ru_RU: 14,
            ja_JP: 34,
            zh_CN: 28,
        };

        let pillPadding = 32;
        if (window.matchMedia('(max-width: 768px)').matches) {
            pillPadding = 24;
        }
        if (window.matchMedia('(max-width: 480px)').matches) {
            pillPadding = 18;
        }
        if (window.matchMedia('(max-width: 425px)').matches) {
            pillPadding = 14;
        }

        let largestBtnWidth = longestBtn * 18 + pillPadding;

        if (locale.getCurrentLocale() == 'ar_AR') {
            largestBtnWidth = longestBtn * charWidth.ar_AR + pillPadding;
        }
        if (locale.getCurrentLocale() == 'fr_FR') {
            largestBtnWidth = longestBtn * charWidth.ar_AR + pillPadding;
        }
        if (locale.getCurrentLocale() == 'ru_RU') {
            largestBtnWidth = longestBtn * charWidth.ru_RU + pillPadding;
        }
        if (locale.getCurrentLocale() == 'ja_JP') {
            largestBtnWidth = longestBtn * charWidth.ja_JP + pillPadding;
        }
        if (locale.getCurrentLocale() == 'zh_CN') {
            largestBtnWidth = longestBtn * charWidth.zh_CN + pillPadding;
        }

        this.setPillMaxWidth(largestBtnWidth);

        /********** SHOW HIDE THE PILL CALCULATION **********/
        let totalLength = 0;
        for (let i = 0; i < btnLabelsLengths.length; i++) {
            totalLength += btnLabelsLengths[i] << 0;
        }
        const introSidePadding = 30;
        let hidePillsAt = totalLength * 11.2 + introSidePadding;

        if (locale.getCurrentLocale() == 'ar_AR') {
            hidePillsAt = totalLength * charWidth.ar_AR + introSidePadding;
        }
        if (locale.getCurrentLocale() == 'fr_FR') {
            hidePillsAt = totalLength * charWidth.ar_AR + introSidePadding;
        }
        if (locale.getCurrentLocale() == 'ru_RU') {
            hidePillsAt = totalLength * (charWidth.ru_RU - 2) + introSidePadding;
        }
        if (locale.getCurrentLocale() == 'ja_JP') {
            hidePillsAt = totalLength * (charWidth.ja_JP - 10) + introSidePadding;
        }
        if (locale.getCurrentLocale() == 'zh_CN') {
            hidePillsAt = totalLength * charWidth.zh_CN + introSidePadding;
        }
        this.updatePillsVisibility(hidePillsAt);
    }

    /**
     * @summary Hides/shows content based on current tab in URL.
     * @since 14.6.3
     */

    public makeTabsConsistent = () => {
        requestAnimationFrame(() => {
            $('.intro .dropdownSelector.mobile').css('visibility', 'visible');
            $('.intro .tabs.desktop').css('visibility', 'visible');

            $('.intro .dropdownSelector.mobile').css('display', 'none');
            $('.intro .tabs.desktop').css('display', 'inline-block');

            const $container = $('.intro .tabs');
            const $tabs = $container.children('.tab');

            // Batch all DOM reads first to prevent forced reflows
            const containerSize = $container.width();
            const windowWidth = $(window).width();
            const tabsCount = $tabs.length;
            const tabMaxWidth = containerSize / tabsCount;

            let largestWidth = 0;
            const tabWidths = [];

            $tabs.each((i, tab) => {
                const $tab = $(tab);
                const width = $tab.width();
                tabWidths.push(width);
                if (width > largestWidth) {
                    largestWidth = width;
                }
            });

            //prevent the tabs from overgrowing container
            if (tabMaxWidth < largestWidth) {
                largestWidth = tabMaxWidth;
            }

            // Batch all DOM writes
            $tabs.each((i, tab) => {
                const $tab = $(tab);
                $tab.css('width', largestWidth + 'px');
            });

            $('.selected-tab').css('width', largestWidth + 'px');

            if (containerSize + 50 > windowWidth) {
                this.convertTabsToDropdown();
            }
        });
    };

    public sendTabAnalytics() {
        //princing.html page only
        if (location.href.includes('/pricing/business-and-enterprise.html?t=')) {
            var pageview = 'pricing';
            if (location.href.includes('/pricing/business-and-enterprise.html?t=b')) {
                pageview = 'business-pricing';
            } else if (location.href.includes('/pricing/business-and-enterprise.html?t=b')) {
                pageview = 'enterprise-pricing';
            }

            if (
                typeof ga !== 'undefined' &&
                typeof ga.h !== 'undefined' &&
                typeof ga.h.gtm2 !== 'undefined'
            ) {
                ga.h.gtm2.send('send', 'pageview', pageview);
            }
        }
    }

    public selectTab = tab => {
        if (!tab) {
            tab = $('[data-tab-default]').data('tab-default');
        }

        $('[data-tab]').removeClass('active');
        $("[data-tab='" + tab + "']").addClass('active');
        //console.log(tab);

        $('[data-tab-change]').removeClass('selected');
        $("[data-tab-change='" + tab + "']").addClass('selected');

        $('[data-tab-change]').off('click');
        $('[data-tab-change]').click('click', e => {
            e.preventDefault();

            this.selectTab($(e.target).data('tab-change'));
            try {
                document.dispatchEvent(
                    new CustomEvent('tab_change', {
                        detail: {
                            tab: $(e.target).data('tab-change'),
                        },
                    })
                );
            } catch (e) {
                console.warn(e);
            }
            this.sendTabAnalytics();
        });

        this.animateTab(tab, $("[data-tab-change='" + tab + "']").parents('.tabs'));

        let href =
            window.location.origin +
            window.location.pathname +
            window.location.search +
            window.location.hash;
        const url = new URL(href);
        url.searchParams.set('t', tab);
        href = url.pathname + url.search + url.hash;
        URLManager.getInstance().changePathInURL(href);
    };

    public animateTab = (tab, tabParent) => {
        // 1. Divide 100% by amount of tabs, this will be 'left' value
        const $tabs = $(tabParent);
        const amountTabs = $tabs.children('.tab').length;
        let selectedTab;

        $($tabs.children('.tab')).each((i, item) => {
            const $anchor = $(item).children('a');
            if ($anchor.data('tab-change') === tab) {
                selectedTab = i;
            }
        });

        let margin = 100 / amountTabs;
        margin = margin * selectedTab;

        if (Locale.getInstance().getCurrentLocale() === 'ar_AE') {
            $('.selected-tab').css('margin-right', margin + '%');
        } else {
            $('.selected-tab').css('margin-left', margin + '%');
        }

        $('.selected-tab').addClass('loaded');
    };

    public convertSecondaryToDropdown = function (elementToConvert) {
        let urlManager = URLManager.getInstance();
        $(elementToConvert).css('display', 'inline-block');

        const $select = $(elementToConvert);
        this.dropdown(elementToConvert, null, 'dropdown field');

        if (urlManager.getParams()['t'] === undefined) {
            urlManager.changePathInURL(
                window.location.pathname + '?t=' + $('[data-tab-default]').data('tab-default')
            );
        }

        $select.children().each((i, tab) => {
            const $tab = $(tab);
            if (window.location.href.indexOf(tab.value) > -1) {
                $select.children().removeAttr('selected');
                $tab.attr('selected', 'selected');
                $select.val(tab.value).trigger('change');
            }
        });

        $select.on('change', e => {
            try {
                const path = $(e.target).val();
                const url = new URL(path, window.location.origin);
                if (
                    url &&
                    (url.search !== window.location.search ||
                        window.location.pathname.indexOf(url.pathname) === -1)
                ) {
                    window.location = url.href;
                }
            } catch (e) {
                console.error(e);
            }

            return false;
        });
    };

    public convertTabsToDropdown = () => {
        let urlManager = URLManager.getInstance();
        $('.intro .dropdownSelector.mobile').css('display', 'inline-block');
        $('.intro .tabs.desktop').css('display', 'none');

        const $select = $('.intro .dropdownSelector.mobile select');

        if (urlManager.getParams()['t'] === undefined) {
            urlManager.changePathInURL(
                window.location.pathname + '?t=' + $('[data-tab-default]').data('tab-default')
            );
        }

        $select.children().each((i, tab) => {
            const $tab = $(tab);
            if (window.location.href.indexOf(tab.value) > -1) {
                $select.children().removeAttr('selected');
                $tab.attr('selected', 'selected');
                $select.val(tab.value).trigger('change');
            }
        });

        this.dropdown('.intro .dropdownSelector.mobile select', null, 'dropdown field');

        //IOS hack!!! select not working in IOS
        this.domReady(() => {
            setTimeout(function () {
                $('.fs-dropdown-selected').text($('.fs-dropdown-element  option.selected').text());
            }, 0);
        });

        $select.on('change', e => {
            //console.log('change' + $(e.target).val());
            try {
                const path = $(e.target).val();
                const url = new URL(path, window.location.origin);
                if (
                    url &&
                    (url.search !== window.location.search ||
                        window.location.pathname.indexOf(url.pathname) === -1)
                ) {
                    window.location = url.href;
                }
            } catch (e) {
                console.error(e);
            }

            return false;
        });
    };

    public registerTabs = whitelist => {
        let urlManager = URLManager.getInstance();
        let windowWidth = $(window).width();
        let resizeTimeout;

        $(window).on('resize', e => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const currentWidth = $(window).width();
                if (currentWidth != windowWidth) {
                    // Update the window width for next time
                    windowWidth = currentWidth;

                    this.makeTabsConsistent();
                }
            }, 150); // Debounce resize events
        });

        this.makeTabsConsistent();

        $(() => {
            const tab = urlManager.getParams()['t'];

            if (whitelist.includes(tab)) {
                this.selectTab(tab);
            } else {
                this.selectTab(null);
            }

            try {
                document.dispatchEvent(new Event('tab_change'));
                if (tab == 'undefined' || typeof tab == 'undefined') {
                    urlManager.replaceURI(urlManager.removeParam('t'));
                }
            } catch (e) {
                console.warn(e);
            }
        });
        this.sendTabAnalytics();
    };

    public onScrollHeaderButtonEffect = () => {
        var windowScrollPos = $(window).scrollTop();

        if (windowScrollPos >= 224) {
            $('header.header .navigation .minibar').addClass('scrolled');
        } else if (windowScrollPos <= 124) {
            $('header.header .navigation .minibar').removeClass('scrolled');
        }
    };

    /**
     * @summary website lives under www and some apps console are using window.opener
     * @param {string} url - URl to the app
     */

    public openKeeperSecurityLink = url => {
        const w = window.open(url, '_blank');
        w.opener = null;
    };

    /**
     * @summary Calls the material design component handler to refresh material design elements.
     * @since 15.6.0
     */

    public refreshMaterialDesign() {
        // fix radios rendering for Edge
        if (Environment.getInstance().whatBrowser() == 'edge') {
            var existingUpgradeElements = $('.mdl-js-radio.is-upgraded').get();
            if (existingUpgradeElements && existingUpgradeElements.length > 0) {
                componentHandler.downgradeElements(existingUpgradeElements);
                componentHandler.upgradeElements(existingUpgradeElements);
            }
        }

        try {
            componentHandler.upgradeDom();
        } catch (e) {
            console.warn(e);
        }
    }

    /**
     * @summary Calculates the visibility of an element on the page.
     * @param {string} element - The element to calculate visibility for.
     * @param {string} offsetPercentage - The offset perecentage to use for the calculation.
     * @since 16.19.6
     */
    public calculateVisibility(element, offsetPercentage) {
        var bounding = element.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var offsetFromBottom = (viewportHeight * offsetPercentage) / 100;
        var visibleHeight =
            Math.min(bounding.bottom, viewportHeight - offsetFromBottom) - bounding.top; // Math.max(bounding.top, offsetFromBottom)
        var visiblePercentage = (Math.max(0, visibleHeight) / bounding.height) * 100;

        // Check if the element has been scrolled past
        if (bounding.bottom < 0) {
            return 100;
        } else if (bounding.bottom < viewportHeight - offsetFromBottom && offsetPercentage > 0) {
            return;
        }

        return Math.min(100, Math.max(0, visiblePercentage));
    }

    /**
     * @summary Sets the inViewPercent CSS variable for elements with the 'data-calc-visibility' data attribute.
     * @since 16.19.6
     */
    public setInViewPercents() {
        var elements = $(document).find('[data-calc-visibility]');
        var self = this;

        // Batch all calculations to prevent forced reflows
        requestAnimationFrame(() => {
            const calculations = [];

            // First pass: collect all calculations (DOM reads)
            $.each(elements, function (index, element) {
                let offsetPercentage = $(element).data('animation-offset') ?? 30;
                let visibility = self.calculateVisibility(element, offsetPercentage);
                calculations.push({element, visibility});
            });

            // Second pass: apply all changes (DOM writes)
            calculations.forEach(({element, visibility}) => {
                if (visibility) {
                    $(element).css('--inViewPercent', visibility);
                }
            });
        });
    }

    /**
     * @summary Runs callbacks associated with our FormStone dropdowns.
     * @since 12.0.0
     */
    public runDropDownReadyCallback() {
        if (!window.dropDownReadyCallbacks) {
            return;
        }

        window.dropDownReadyCallbacks.forEach(option => {
            if (option && {}.toString.call(option) === '[object Function]') {
                option();
            }
        });
    }
}

export default UI;
